<template>
  <div class="siteBookings">
    <div class="panelheader">
      <div class="title">Bookings</div>
    </div>
    <el-table
      :data="bookings"
      style="width: 100%"
      empty-text="No Bookings"
      class="field-table no-pointer">
      <el-table-column
        prop="date"
        label="Date"
        header-align="center">
      </el-table-column>
       <el-table-column
        prop="field_name"
        label="Field"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="scene_name"
        label="Scene"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="Time On"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="Time Off"
        header-align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import requests from '../requests';
  import { formatTime, getHourTime } from '../javascript/helpers'

  export default {
    name: 'siteBookings',
    data(){
      return {
        bookings:[]
      }
    },
    beforeMount(){
      var context = this;
      requests.getSiteBookings(this, this.$route.params.id, function(result){
        if(result && result.data && result.data.length > 0){
          for(var i = 0; i < result.data.length; i++){

            //var s = result.data[i].start_date.split(' ')[1];
            var d1 = new Date(result.data[i].start_date);
            result.data[i].start_time = formatTime(d1.getHours(), d1.getMinutes()) + getHourTime(d1.getHours());

            var d2 = new Date(result.data[i].end_date);
            result.data[i].end_time = formatTime(d2.getHours(), d2.getMinutes()) + getHourTime(d2.getHours());

            var date = result.data[i].start_date.split(' ')[0];
            date = date.split('-');
            date = date[2] + '/' + date[1] + '/' + date[0];


            result.data[i].date = date;
            context.bookings.push(result.data[i]);
          }
        }
      });
    },
    socket: {
      events: {
        //@params: data : {date, field_name, scene_name, start_time, end_time}
        newBooking: function(data){
          if(data && data.type && data.type == "update_all"){
            var start_date = data.start_time;
            var end_date = data.end_time;
          } else {
            var start_date = data.date + ' ' + data.start_time;
            var end_date = data.date + ' ' + data.end_time;
          }

          var d1 = new Date(start_date);
          data.start_time = formatTime(d1.getHours(), d1.getMinutes()) + getHourTime(d1.getHours());
          
          var d2 = new Date(end_date);
          data.end_time = formatTime(d2.getHours(), d2.getMinutes()) + getHourTime(d2.getHours());

          var date = start_date.split(' ')[0];
          date = date.split('-');
          date = date[2] + '/' + date[1] + '/' + date[0];

          this.bookings.push(data);
        },
        error(err) {
          console.error("Websocket error: ", err);
        }
      }
    },
  }
</script>

<style>

 .bookings .field-table .el-table__body, .bookings .field-table .el-table__header {
    width: unset !important;
  }

  .no-pointer .el-table__row {
    cursor: default !important;
  }
</style>


// WEBPACK FOOTER //
// SiteBookings.vue?58976374